import React from 'react';
import Grid from '@mui/material/Grid2';
import { Spa, Face, Carpenter } from '@mui/icons-material'; // Icons for extra services
import DashboardButton from './DashboardButton';
import Typography from '@mui/material/Typography';

const extras = [
  { name: "Waschen", icon: <Spa fontSize="large" />, price: 3 },
  { name: "AugenBrauen Zupfen", icon: <Face fontSize="large" />, price: 5 },
  { name: "AugenBrauen mit Messer", icon: <Carpenter fontSize="large" />, price: 3 },
];

const ExtrasSelection = ({ selectedExtras, handleExtraSelection }) => {
  return (
    <>
      <Typography component="h2" variant="h6" sx={{ mb: 3, fontWeight: 500 }}>
        Select Extra Services
      </Typography>
      <Grid container spacing={3} sx={{ mb: 5 }}>
        {extras.map((extra) => (
         <Grid
              size={{ xs: 6, sm: 12 }} // 2 per row on mobile, full width on sm+
              key={extra.name}
              sx={{ 
                display: { sm: 'inline-flex' }, // Remove Grid styling on larger screens
                maxWidth: { sm: '200px' } // Match DashboardButton's sm width
              }}
            >
            <DashboardButton
              text={`${extra.name}`}
              secondaryText={`€${extra.price}`}
              icon={extra.icon}
              selected={selectedExtras.some(item => item.name === extra.name)}  // Check if extra is in selectedExtras array
              onClick={() => handleExtraSelection(extra)}  // Pass the entire extra object
              size="small"
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ExtrasSelection;
